import React from 'react';
import { BookIcon, TagIcon, UsersIcon, HeadphonesIcon, ShoppingBagIcon, CalendarIcon, BookOpenIcon, HeartIcon, ClipboardListIcon, StarIcon, HomeIcon, TrendingUpIcon, LibraryIcon, BookmarkIcon, MessageSquareIcon, SearchIcon, TrophyIcon, PenToolIcon, ImageIcon, PackageIcon, MapPinIcon, StoreIcon, HeartHandshakeIcon, AlertCircleIcon, FlameIcon, UserIcon, BellIcon, LayoutGridIcon, ZapIcon, LinkIcon, GlobeIcon, CompassIcon, SparklesIcon, LayersIcon, BuildingIcon } from 'lucide-react';
import { MenuSection } from './types';
export const readerMenuSections: MenuSection[] = [{
  id: 'home',
  label: 'Home',
  icon: <HomeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2415" data-mp="2cq91i7tqu7ji" />,
  to: '/'
}, {
  id: 'browse',
  label: 'Browse Books',
  icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2416" data-mp="fwnv4vmxek0m" />,
  children: [{
    label: 'All Books',
    to: '/browse',
    icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2417" data-mp="awt7d0yg6ajs" />
  }, {
    label: 'New Releases',
    to: '/new-books',
    icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2418" data-mp="2615urihoehw" />
  }, {
    label: 'Bestsellers',
    to: '/bestsellers',
    icon: <TrendingUpIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2419" data-mp="3kd8fmwe6htjn" />
  }, {
    label: 'Series',
    to: '/series',
    icon: <LibraryIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2420" data-mp="guxcql8t7lgx" />
  }, {
    label: 'Anthologies',
    to: '/anthologies',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2421" data-mp="lsgrrndc029x" />
  }, {
    label: 'Book Graphics',
    to: '/books/graphics',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2422" data-mp="c3yrr8cvlz7c" />
  }]
}, {
  id: 'discover',
  label: 'Discover',
  icon: <CompassIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2423" data-mp="zt9jk0c90j9c" />,
  children: [{
    label: 'Story Galaxy',
    to: '/story-galaxy',
    icon: <SparklesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2424" data-mp="14m2rex30k7pn" />
  }, {
    label: 'Story Stack',
    to: '/story-stack',
    icon: <LayersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2425" data-mp="19gvq3g3sogo4" />
  }, {
    label: 'Book Discovery',
    to: '/discover',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2426" data-mp="14k5aetvwjn38" />
  }]
}, {
  id: 'genres',
  label: 'Browse by Genre',
  icon: <TagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2427" data-mp="vh47f22c2c3s" />,
  to: '/genres'
}, {
  id: 'content',
  label: 'Content',
  icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2428" data-mp="qpmcovqwl7r9" />,
  children: [{
    label: 'All Content Tags',
    to: '/all-content-tags',
    icon: <LayoutGridIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2429" data-mp="gsrhalpxfnh7" />
  }, {
    label: 'Tropes',
    to: '/tropes',
    icon: <HeartHandshakeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2430" data-mp="cpl2gpor0nz4" />
  }, {
    label: 'Characters',
    to: '/characters',
    icon: <UserIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2431" data-mp="2jf5814w91c0k" />
  }, {
    label: 'Relationship Types',
    to: '/relationship-types',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2432" data-mp="2ocwwfoxoqg00" />
  }, {
    label: 'Pairing Types',
    to: '/pairing-types',
    icon: <LinkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2433" data-mp="2xextolsx521o" />
  }, {
    label: 'Spice & Darkness',
    to: '/spice-darkness',
    icon: <FlameIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2434" data-mp="20pyk93gllu7w" />
  }, {
    label: 'Burn Levels',
    to: '/burn-levels',
    icon: <ZapIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2435" data-mp="24nw8o42joca8" />
  }, {
    label: 'Ending Types',
    to: '/ending-types',
    icon: <BookmarkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2436" data-mp="2egbwhi0ivv31" />
  }, {
    label: 'Representation',
    to: '/representation',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2437" data-mp="1gytvp9iuv7m2" />
  }, {
    label: 'Cultural Identity',
    to: '/cultural-identity',
    icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2438" data-mp="3onhj5u531npd" />
  }, {
    label: 'Themes',
    to: '/themes',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2439" data-mp="3jp66lbnekz3g" />
  }, {
    label: 'Book Settings',
    to: '/settings',
    icon: <MapPinIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2440" data-mp="3snhvn98mfots" />
  }, {
    label: 'Content Warnings',
    to: '/content-warnings',
    icon: <AlertCircleIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2441" data-mp="b5p18ayknpe0" />
  }]
}, {
  id: 'authors',
  label: 'Explore Authors',
  icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2442" data-mp="k8q5e63vn6f1" />,
  children: [{
    label: 'All Authors',
    to: '/authors',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2443" data-mp="g74n258kpzxg" />
  }, {
    label: 'New Authors',
    to: '/authors/new',
    icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2444" data-mp="2hy998lrqm8ae" />
  }, {
    label: 'Award Winners',
    to: '/authors?filter=award-winners',
    icon: <TrophyIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2445" data-mp="27uuih0s3ze7b" />
  }, {
    label: 'Browse by Genre',
    to: '/authors?filter=by-genre',
    icon: <TagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2446" data-mp="1y518u5bj195p" />
  }]
}, {
  id: 'audio',
  label: 'Audiobooks',
  icon: <HeadphonesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2447" data-mp="231rmklzuzsny" />,
  children: [{
    label: 'All Audiobooks',
    to: '/audiobooks',
    icon: <HeadphonesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2448" data-mp="1t4wmhynxtk7k" />
  }, {
    label: 'Genres',
    to: '/audiobooks/genres',
    icon: <TagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2449" data-mp="1f6ydz9washzz" />
  }, {
    label: 'Audiobook Graphics',
    to: '/audiobooks/graphics',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2450" data-mp="39iva3g5oqc1d" />
  }, {
    label: 'Audiobook Discovery',
    to: '/audiobooks',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2451" data-mp="3ehq1h6hpx8x3" />
  }, {
    label: 'New Releases',
    to: '/audiobooks/new',
    icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2452" data-mp="381pvg29uehj8" />
  }, {
    label: 'Bestsellers',
    to: '/audiobooks/bestsellers',
    icon: <TrendingUpIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2453" data-mp="333emruvaad2l" />
  }, {
    label: 'Series',
    to: '/audiobooks/series',
    icon: <LibraryIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2454" data-mp="3vsbs6xeecfdx" />
  }, {
    label: 'Browse Narrators',
    to: '/narrators',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2455" data-mp="3qtiotxstq4rh" />
  }]
}, {
  id: 'trove',
  label: 'Trove',
  icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2456" data-mp="3lznwk5z5khgs" />,
  children: [{
    label: 'All Articles & News',
    to: '/trove',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2457" data-mp="idp8biyhstaf" />
  }, {
    label: 'Trove Updates',
    to: '/trove/updates',
    icon: <BellIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2458" data-mp="kxd6a2an6r5v" />
  }, {
    label: 'Awards & Recognition',
    to: '/trove/awards',
    icon: <TrophyIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2459" data-mp="px7we3mlfcpv" />
  }, {
    label: 'Genre Spotlights',
    to: '/trove/genres',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2460" data-mp="zumc210ozxh4" />
  }, {
    label: 'Audio & Narration',
    to: '/trove/audio',
    icon: <HeadphonesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2461" data-mp="13vg0cvi1reaj" />
  }, {
    label: 'Industry Events',
    to: '/trove/events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2462" data-mp="1dm0vg8yii0op" />
  }, {
    label: 'Got a Story Stuck in Your Head?',
    to: '/trove/story-in-your-head',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2463" data-mp="1in6pca3wrtzt" />
  }]
}, {
  id: 'merch',
  label: 'Book Boxes & Merch',
  icon: <ShoppingBagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2464" data-mp="1rladzfa6x6vu" />,
  children: [{
    label: 'Merch Business Profiles',
    to: '/merch-business-profiles',
    icon: <StoreIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2465" data-mp="28v5fslmzhv8r" />
  }, {
    label: 'Book Boxes',
    to: '/book-boxes',
    icon: <PackageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2466" data-mp="2mtveu6td64zr" />
  }, {
    label: 'Clothing',
    to: '/merch/clothing',
    icon: <TagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2467" data-mp="2hu0mrzxur9d4" />
  }, {
    label: 'Accessories',
    to: '/merch/accessories',
    icon: <TagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2468" data-mp="1p7xsfybv5fij" />
  }, {
    label: 'Art Prints',
    to: '/merch/art-prints',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2469" data-mp="23y59c9m82qh4" />
  }, {
    label: 'Home & Living',
    to: '/merch/home-living',
    icon: <HomeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2470" data-mp="1beznbk9mc91s" />
  }]
}, {
  id: 'bookstores',
  label: 'Bookstores',
  icon: <StoreIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2471" data-mp="16g55olne0qj9" />,
  children: [{
    label: 'Browse All Bookstores',
    to: '/bookstores',
    icon: <StoreIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2472" data-mp="3mv9vx622onur" />
  }, {
    label: 'Brick & Mortar',
    to: '/bookstores?type=brick-and-mortar',
    icon: <MapPinIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2473" data-mp="391ip45fq7i2q" />
  }, {
    label: 'Online Stores',
    to: '/bookstores?type=online-only',
    icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2474" data-mp="4qf2j9whtb3y" />
  }, {
    label: 'Signed Copies',
    to: '/bookstores?feature=signedCopies',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2475" data-mp="3rucse23zllr4" />
  }]
}, {
  id: 'events',
  label: 'Events',
  icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2476" data-mp="m7bh62kbj2k" />,
  children: [{
    label: 'View All Events',
    to: '/events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2477" data-mp="2ldrdz55x9b31" />
  }, {
    label: 'Author Events',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2478" data-mp="1qk4qsp0avy24" />,
    children: [{
      label: 'Book Signings',
      to: '/events/book-signings',
      icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2479" data-mp="1guuwr3lwc5bd" />
    }, {
      label: 'Book Launches',
      to: '/events/book-launches',
      icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2480" data-mp="1lrtq3jxqk88i" />
    }, {
      label: 'Author Talks',
      to: '/events/author-talks',
      icon: <MessageSquareIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2481" data-mp="1bwjlqpjv7ork" />
    }, {
      label: 'Author Panels',
      to: '/events/author-panels',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2482" data-mp="12uafwczjkjki" />
    }, {
      label: 'Multi-Author Signings',
      to: '/events/multi-author-signings',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2483" data-mp="2x9mqbjus3im9" />
    }]
  }, {
    label: 'Reader Community',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2484" data-mp="37d9v5029no24" />,
    children: [{
      label: 'Local Author Events',
      to: '/events/local-authors',
      icon: <MapPinIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2485" data-mp="3g65341j4bxvl" />
    }, {
      label: 'Reading Meetups',
      to: '/events/reading-meetups',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2486" data-mp="3q2q8inz1vazy" />
    }, {
      label: 'Book Swaps',
      to: '/events/book-swaps',
      icon: <HeartHandshakeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2487" data-mp="2ytjot37ebqx" />
    }]
  }, {
    label: 'Book Clubs',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2488" data-mp="3v3xh2p90oe7o" />,
    children: [{
      label: 'In-Person Book Clubs',
      to: '/events/book-clubs/in-person',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2489" data-mp="20pmpi911f5y7" />
    }, {
      label: 'Virtual Book Clubs',
      to: '/events/book-clubs/virtual',
      icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2490" data-mp="8m8oux3gf5sp" />
    }, {
      label: 'Silent Book Clubs',
      to: '/events/silent-book-clubs',
      icon: <BookmarkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2491" data-mp="iky9gxmqj4cn" />
    }]
  }, {
    label: 'Conferences & Festivals',
    icon: <BuildingIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2492" data-mp="mm9xwztvhjj9" />,
    children: [{
      label: 'Conventions & Festivals',
      to: '/events/conventions-festivals',
      icon: <BuildingIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2493" data-mp="wdeeu533zegq" />
    }, {
      label: 'Reading Retreats',
      to: '/events/reading-retreats',
      icon: <CompassIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2494" data-mp="16c3l10ln7ah5" />
    }, {
      label: 'Midnight Releases',
      to: '/events/midnight-releases',
      icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2495" data-mp="2uuoj4vcwr19u" />
    }]
  }, {
    label: 'Workshops & Learning',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2496" data-mp="2quxq0kzws925" />,
    children: [{
      label: 'Writing Workshops',
      to: '/events/writing-workshops',
      icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2497" data-mp="2gwhum5tumdmu" />
    }, {
      label: 'Publishing Workshops',
      to: '/events/publishing-workshops',
      icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2498" data-mp="39juiqkfnqti9" />
    }, {
      label: 'Craft Masterclasses',
      to: '/events/craft-masterclasses',
      icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2499" data-mp="2zsq3rkpzf8nf" />
    }]
  }, {
    label: 'Online Events',
    icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2500" data-mp="15c6e6ioorsu" />,
    children: [{
      label: 'Virtual Author Events',
      to: '/events/virtual-author-events',
      icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2501" data-mp="3d29slf4na8s9" />
    }, {
      label: 'Livestream Discussions',
      to: '/events/livestream-discussions',
      icon: <MessageSquareIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2502" data-mp="3343uz9pvfot7" />
    }, {
      label: 'Online Workshops',
      to: '/events/online-workshops',
      icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2503" data-mp="3vr6nnl7v95bj" />
    }]
  }, {
    label: 'Free Events',
    to: '/events/free',
    icon: <SparklesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2504" data-mp="3m1n38b4i93ek" />
  }, {
    label: 'View All Events',
    to: '/events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2505" data-mp="3qxvevejhuegz" />
  }]
}];
export const readerListsSections: MenuSection[] = [{
  id: 'lists',
  label: 'Your Lists',
  icon: <BookmarkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2506" data-mp="nc66vne2tj34" />,
  children: [{
    label: 'My Bookshelf',
    to: '/my-bookshelf',
    icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2507" data-mp="232pas1lv8ptz" />
  }, {
    label: 'My Tracker',
    to: '/my-tracker',
    icon: <BookmarkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2508" data-mp="2gt2j452o66ju" />
  }, {
    label: 'New Release Tracker',
    to: '/new-release-tracker',
    icon: <TrendingUpIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2509" data-mp="1p1wf3djtvopa" />
  }, {
    label: 'Wishlist',
    to: '/wishlist',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2510" data-mp="1k55x2kogqj18" />
  }, {
    label: 'Book Lists',
    to: '/book-lists',
    icon: <LibraryIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2511" data-mp="1t49i3u76x8id" />
  }, {
    label: 'Reading History',
    to: '/reading-history',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2512" data-mp="39gokr7sc7142" />
  }, {
    label: 'Saved Events',
    to: '/saved-events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2513" data-mp="2260k99cnar5w" />
  }, {
    label: 'My Orders',
    to: '/my-orders',
    icon: <ClipboardListIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2514" data-mp="273ijg80v1s0p" />
  }, {
    label: 'My Reviews',
    to: '/my-reviews',
    icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2515" data-mp="2g5jf50gg4609" />
  }, {
    label: 'Messages',
    to: '/messages',
    icon: <MessageSquareIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2516" data-mp="1jgafpuj2yr0s" />
  }]
}];